import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OutageBannerComponent } from './outage-banner/outage-banner.component';



@NgModule({
  declarations: [
    OutageBannerComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [OutageBannerComponent]
})
export class OutageBannerModule { } 
